import React, {useEffect, useRef, useState} from 'react';
import HTMLFlipBook from 'react-pageflip';
import {FaArrowLeft, FaArrowRight} from "react-icons/fa";


const CurriculumFlipbookContent = ({contentData}) => {
    const flipBookRef = useRef(null);
    const handleNext = () => {
        if (flipBookRef.current) {
            flipBookRef.current.pageFlip().flipNext();
        }
    };

    const handlePrev = () => {
        if (flipBookRef.current) {
            flipBookRef.current.pageFlip().flipPrev();
        }
    };
    // Sort the contentData based on an 'order' property
    const sortedContent = contentData?.sort((a, b) => a.ordering - b.ordering);
    const [flipBookSize, setFlipBookSize] = useState({ width: 500, height: 700 });

    // Adjust flipbook size dynamically based on screen size
    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;

            if (screenWidth <= 480) {
                // Mobile
                setFlipBookSize({ width: 400, height: 600 });
            } else if (screenWidth <= 768) {
                // Tablet
                setFlipBookSize({ width: 400, height: 600 });
            } else {
                // Desktop
                setFlipBookSize({ width: 500, height: 700 });
            }
        };

        // Initial resize
        handleResize();

        // Listen for screen size changes
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>
        <div className='flipbook-container mt-10 border-none'>
            <HTMLFlipBook
                ref={flipBookRef}
                width={flipBookSize.width}
                height={flipBookSize.height}
                size="stretch"
                minWidth={200}
                maxWidth={500}
                minHeight={300}
                maxHeight={700}
                drawShadow={true}
                flippingTime={1000}
                usePortrait={true}
                startZIndex={0}
                autoSize={true}
                maxShadowOpacity={1}
                showCover={true}
                mobileScrollSupport={true}
                className="flipbook"
            >
                {sortedContent?.map((data, index) => (
                    <div className={index === 0 ? "page cover" : "page"} key={index}>
                        <img
                            src={data.url}
                            loading="lazy"
                            alt={index === 0 ? "Cover Page - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project" : `Page ${index} - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project`}
                            title={index === 0 ? "Cover Page - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project" : `Page ${index} - Explore STEMCity | Educational Kit | Robotics | STEM Learning | DIY Project`}
                            className="page-image"
                        />
                    </div>
                ))}
            </HTMLFlipBook>
        </div>
            <div className="flex justify-around m-5 lg:mr-96 xl:mr-96 ">
                <button onClick={handlePrev} className="prev-button"><FaArrowLeft className="text-xl text-gray-600 hover:text-red-600 dark:text-gray-400" /></button>
                <button onClick={handleNext} className="next-button"><FaArrowRight className="text-xl text-gray-600 hover:text-red-600 dark:text-gray-400" /></button>
            </div>
    </>

    );
};

export default CurriculumFlipbookContent;
